import CustomerDue from '../timetable/customerDue';
export default function CustomerDueTab(props) {

    const projectId = props.projectId
return (
    <div>
        <CustomerDue isInProject = {true} projectId = {projectId}></CustomerDue>
    </div>
)};